import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import I18n from 'i18n-react';

import './OverviewBreadcrumb.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string),
  actual: PropTypes.string
};

const defaultProps = {
  steps: [],
  actual: ''
};

class OverviewBreadcrumb extends React.Component {
  indexOfActual(steps) {
    let index = steps.indexOf(this.props.actual) + 1;
    if (index < 1) {
      index = steps.length;
    }
    return index;
  }

  renderHTMLStep(key, name) {
    return (
      <span
        key={key}
        className={name === this.props.actual ? 'OverviewBreadcrumb__actualStep' : ''}>
        {I18n.translate(name)}
      </span>
    );
  }

  renderHTMLNext(key) {
    return (
      <span key={key} className="OverviewBreadcrumb__nextStep">
        <span> > </span>
      </span>
    );
  }

  renderSteps(typeName, typeSteps, firstNext) {
    const steps = [];
    typeSteps.forEach((name, index) => {
      if (firstNext || index > 0) {
        steps.push(this.renderHTMLNext(`${typeName}-next-${index}`));
      }
      steps.push(this.renderHTMLStep(`${typeName}-step-${index}`, name));
    });
    return steps;
  }

  renderAllSteps() {
    const steps = this.props.steps;
    const enableSteps = steps.slice(0, this.indexOfActual(steps));
    const disableSteps = steps.slice(enableSteps.length, steps.length);

    return (
      <span>
        <span className="OverviewBreadcrumb__enableSteps">
          {this.renderSteps('enableSteps', enableSteps, false)}
        </span>
        <span className="OverviewBreadcrumb__disableSteps">
          {this.renderSteps('disableSteps', disableSteps, true)}
        </span>
      </span>
    );
  }

  render() {
    return (
      <div id={this.props.id} className="OverviewBreadcrumb">
        <Row>
          <Col xsHidden={true} sm={12} md={12} lg={12} className="OverviewBreadcrumb__steps">
            <span className="OverviewBreadcrumb__stepContent">{this.renderAllSteps()}</span>
          </Col>
        </Row>
      </div>
    );
  }
}

OverviewBreadcrumb.propTypes = propTypes;
OverviewBreadcrumb.defaultProps = defaultProps;

export default OverviewBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb.jsx